import { createFileRoute } from '@tanstack/react-router'

import PageTools from '../pages/PageTools'

export const Route = createFileRoute('/tools/')({
  component: PageTools
})
